<template>
  <a :href="exhibit.url" class="cursor-pointer">
    <div class="relative rounded-md overflow-hiddenw-full bg-gray h-250">
      <div class="absolute top-0 bottom-0 left-0 right-0 opacity-50 bg-gradient-to-t from-black/5 rounded-10"/>
      <img :src="exhibit.images.background.lg"
        :alt="exhibit.images.altImage"
        class="object-cover object-center w-full h-full rounded-10"/>
      <div>
        <div class="absolute bottom-0 left-0 w-11/12 mb-16 ml-16 leading-5 text-white rounded-10 ">
          <h3 class="mb-16 leading-tight text-22 exhibit-title-shadow">{{ exhibit.title }}</h3>
          <div class="flex flex-wrap gap-10">
            <div v-for="location in exhibit.locations" :key="location.id">
              <a :href="location.url" class="flex items-center py-6 leading-none bg-white rounded-full px-14 text-14 text-shadow text-orange w-fit">
                <i class="mr-6 fas fa-map-marker-alt"></i>
                <h3 style="font-size: 12px;font-family: sans-serif;font-weight: 800;"> {{ location.name }} </h3>
              </a>
            </div>
          </div>
        </div>
      </div>
      
      <a :href="exhibit.url"
          class="absolute top-0 right-0 px-24 text-white rounded-tr-lg rounded-bl-lg bg-orange py-18 mb-36 text-14">
          {{ exhibit.buttonName ? exhibit.buttonName : 'View Exhibit'  }} <i class="ml-6 fal fa-long-arrow-right"></i>
      </a>
    </div>
  </a>
</template>

<script>
export default {
  name: "TheOngoingExhibitPanel",

  props: {
    exhibit: {
      required: true,
    },
  },
};
</script>

<style scoped>
.text-outline {
  -webkit-text-stroke: 1px black;
}
.exhibit-title-shadow {
  text-shadow: 0px 0px 20px rgba(0,0,0,0.80);
}
</style>